/**
 * @module CareersApp
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { callSegmentTrack } from '@lifechurch/web-tools-io/dist/utils/helpers/analytics';
import { Log } from '@lifechurch/web-tools-io/dist/utils/helpers/browserLogger';
import { getQueryParam } from '@lifechurch/web-tools-io/dist/utils/helpers/queryParams';
import { injectScript } from '@lifechurch/web-tools-io/dist/utils/helpers/scriptHelper';
import { useScrollTracker } from 'react-scroll-tracker';
import CareersHeader from '../../components/CareersHeader/CareersHeader';
import Footer from '../../components/Footer/Footer';
import fetchCareersTemplate from '../../helpers/dataFetchers/careersTemplateFetcher';
import { CONSENT_MANAGER_THIRD_PARTY_SERVICES, EVENTS } from '../../helpers';
import './careers.scss';

const CareersApp = (props) => {
  const [data, setData] = React.useState(null);

  /**
   * Use local user var since auth may not yet be configured, and the useAuth
   * hook might not be fully configured and initialized at this point.
   */
  let user;
  try {
    user = window?.localStorage?.getItem('user_profile')
      ? JSON.parse(window?.localStorage?.getItem('user_profile'))
      : null;
  } catch (error) {
    Log.error(error);
  }

  /**
   * Implement scroll depth tracking and fire off Segment when thresholds met.
   */
  useScrollTracker([50], ({ scrollY }) => {
    callSegmentTrack({
      event: EVENTS.pageScrolled,
      properties: {
        depth: scrollY / 100,
        logged_in: !!user,
        preferred_campus: null,
        referrer: document?.referrer || null,
        title: document?.title || '',
        url: window?.location?.href,
        user_id: user?.['https://www.life.church/rock_person_alias_id'],
      },
    });
  });

  /**
   * Single-run convenience effect to fetch Careers template data.
   */
  React.useEffect(() => {
    async function fetchData() {
      try {
        const theme = getQueryParam('theme');
        const careersTemplateData = await fetchCareersTemplate(props, theme);
        setData(careersTemplateData);
      } catch (error) {
        Log.error(error);
      }
    }
    fetchData(); // NOSONAR
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Convenience effect to inject third party scripts.
   */
  React.useEffect(() => {
    const { markups } = CONSENT_MANAGER_THIRD_PARTY_SERVICES.google;
    injectScript(markups.googleOptimizeScript, true);
    injectScript(markups.leadershipPodcastAdTracking, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {data?.menuData ? (
        <CareersHeader
          menuData={data.menuData}
          menuItems={data.menuItems}
          navItems={data.navItems}
        />
      ) : null}
      {props.children}
      {data?.footerData ? <Footer footerData={data.footerData} /> : null}
    </>
  );
};

export default CareersApp;
